var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$s.projects.value)?_c('Nuxt'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }